import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ecc8906"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["title"]
const _hoisted_2 = { class: "list-text-value" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 16 16",
  fill: "none",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "5",
    y: "5",
    width: "9",
    height: "9",
    rx: "1",
    stroke: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10 3V2H2v8h1",
    stroke: "currentColor"
  })
], -1))
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(['list-text', _ctx.kind === 'order' ? 'list-order-number' : 'list-product-name', {'list-text-responsive':_ctx.responsiveEnabled,'list-text-wrap':_ctx.responsiveEnabled && _ctx.wrap && _ctx.kind!=='order'}]),
    title: _ctx.fullText
  }, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.displayText), 1),
    (_ctx.kind === 'order' && _ctx.fullText)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "copy-order-button",
          title: "复制完整订单号",
          "aria-label": "复制完整订单号",
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.copyNumber && _ctx.copyNumber(...args)), ["stop"]))
        }, _hoisted_4))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}